import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgIkonKontaktarbejdsgiver({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            id="ikon_kontaktarbejdsgiver_svg__Lag_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 95 72.4"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <defs>
                <style>
                    {'.ikon_kontaktarbejdsgiver_svg__st0{fill-rule:evenodd}'}
                </style>
            </defs>
            <path
                className="ikon_kontaktarbejdsgiver_svg__st0"
                d="m58.8 39.4-3.3 3.3c-2.1 2.1-5 3.3-8 3.3s-5.9-1.2-8-3.3l-3.3-3.3L3.9 71.7c.9.4 1.9.7 2.9.7h81.4c1 0 2-.2 2.9-.7L58.8 39.4ZM.7 3.9 33 36.2.7 68.5c-.4-.9-.7-1.9-.7-2.9V6.8c0-1 .2-2 .7-2.9ZM94.3 3.9c.4.9.7 1.9.7 2.9v58.8c0 1-.2 2-.7 2.9L62 36.2 94.3 3.9Z"
            />
            <path
                className="ikon_kontaktarbejdsgiver_svg__st0"
                d="M91.1.7c-.9-.4-1.9-.7-2.9-.7H6.8c-1 0-2 .2-2.9.7l38.8 38.8c1.3 1.3 3 2 4.8 2s3.5-.7 4.8-2L91.1.7Z"
            />
        </svg>
    )
}
SvgIkonKontaktarbejdsgiver.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgIkonKontaktarbejdsgiver
